/* Holy Cow Cinematic — homepage section animations (ported verbatim from V2 index.html) */
(function () {
  'use strict';
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COARSE = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  var SAVE_DATA = !!(navigator.connection && navigator.connection.saveData);
  var FAST_MODE = SAVE_DATA || window.innerWidth < 640;
  var prefersReduced = REDUCE;

  function run() {

// Hero bag parallax + sheen
if (!COARSE && !REDUCE) {
  const bag = document.getElementById('hero-bag');
  const sheen = document.getElementById('hero-bag-sheen');
  const hero = document.getElementById('hero');
  hero.addEventListener('mousemove', e => {
    const rect = hero.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    gsap.to(bag, { rotationY: x * 16, rotationX: -y * 12, x: x * 18, y: y * 18, duration: 0.8, ease: 'power3.out' });
    if (sheen) {
      const bagRect = bag.getBoundingClientRect();
      const lx = ((e.clientX - bagRect.left) / bagRect.width) * 100;
      const ly = ((e.clientY - bagRect.top) / bagRect.height) * 100;
      sheen.style.background = `radial-gradient(circle at ${lx}% ${ly}%, rgba(255,255,255,0.35), rgba(255,255,255,0) 50%)`;
    }
  });
  hero.addEventListener('mouseleave', () => gsap.to(bag, { rotationY: 0, rotationX: 0, x: 0, y: 0, duration: 1.2, ease: 'expo.out' }));
}

// Canvas dust (rising motes in hero)
if (!REDUCE && !SAVE_DATA) {
  const canvas = document.getElementById('dust');
  const ctx = canvas.getContext('2d');
  let w, h, particles;
  function resize() {
    const hero = document.getElementById('hero');
    w = canvas.width = hero.offsetWidth; h = canvas.height = hero.offsetHeight;
    particles = Array.from({length: 95}, () => {
      const warm = Math.random() > 0.55;
      return {
        x: Math.random()*w, y: Math.random()*h,
        vx: (Math.random()-0.5)*0.3, vy: -Math.random()*0.4-0.06,
        r: Math.random()*1.8+0.35,
        o: Math.random()*0.35+0.12,
        drift: Math.random()*Math.PI*2,
        warm
      };
    });
  }
  resize(); window.addEventListener('resize', resize);
  (function loop() {
    ctx.clearRect(0,0,w,h);
    particles.forEach(p => {
      p.drift += 0.005;
      p.x += p.vx + Math.sin(p.drift)*0.15; p.y += p.vy;
      if (p.y < -10) { p.y = h+10; p.x = Math.random()*w; }
      if (p.x < -10) p.x = w+10; if (p.x > w+10) p.x = -10;
      ctx.fillStyle = p.warm ? `rgba(184,117,78,${p.o * 0.85})` : `rgba(45,74,43,${p.o})`;
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI*2); ctx.fill();
    });
    requestAnimationFrame(loop);
  })();
}

// ============ SOIL PILE — falling particles accumulate into a real pile ============
// Tied to scroll progress through the hero. Particles fall with gravity, settle
// onto a height-map column, and slump sideways (angle of repose simulation).
(function soilPile() {
  if (REDUCE || SAVE_DATA) return;
  const canvas = document.getElementById('soil-pile');
  const ctx = canvas.getContext('2d');
  const hero = document.getElementById('hero');
  let w, h, columns, heightMap, falling, settled;
  const COL_W = 2;          // pixel-resolution of pile height map
  const MAX_SETTLED = 8500; // cap pile size
  const SOIL_COLORS = ['#2a1d12', '#3a2818', '#4a3220', '#3d2b1a', '#5a3e26', '#231910'];

  function resize() {
    w = canvas.width = hero.offsetWidth;
    h = canvas.height = hero.offsetHeight;
    columns = Math.ceil(w / COL_W);
    heightMap = new Float32Array(columns);
    falling = [];
    settled = [];
  }
  function seedInitialPile() {
    // Small mound at the bottom edge only — not under the product bag
    const center = Math.floor(columns / 2);
    const spread = Math.max(10, Math.floor(columns * 0.18));
    for (let col = center - spread; col <= center + spread; col++) {
      if (col < 0 || col >= columns) continue;
      const t = 1 - Math.abs(col - center) / spread;
      heightMap[col] = t * 10 + 2;
    }
    for (let col = 0; col < columns; col++) {
      if (heightMap[col] < 2) continue;
      const surfaceY = h - heightMap[col];
      for (let n = 0; n < 3; n++) {
        if (settled.length >= MAX_SETTLED) break;
        settled.push({
          x: col * COL_W + Math.random() * COL_W,
          y: surfaceY - Math.random() * 2,
          r: 1 + Math.random() * 1.2,
          c: SOIL_COLORS[Math.floor(Math.random() * SOIL_COLORS.length)]
        });
      }
    }
  }

  resize();
  seedInitialPile();
  window.addEventListener('resize', () => { resize(); seedInitialPile(); });

  let scrollProgress = 0;
  let lastSpawnTime = 0;

  function spawn(intensity) {
    const baseRate = 18;
    const count = Math.floor(intensity * baseRate);
    for (let i = 0; i < count; i++) {
      const cx = w * (0.32 + Math.random() * 0.36);
      falling.push({
        x: cx + (Math.random() - 0.5) * 40,
        y: -20 - Math.random() * 100,
        vx: (Math.random() - 0.5) * 0.4,
        vy: 1.5 + Math.random() * 1.2,
        r: 1.2 + Math.random() * 1.3,
        c: SOIL_COLORS[Math.floor(Math.random() * SOIL_COLORS.length)]
      });
    }
  }

  function slump(col) {
    // Angle-of-repose: if neighbor is much lower, spill one unit sideways
    const STEEP = 4; // max height diff before sideways spill
    if (col > 0 && heightMap[col] - heightMap[col-1] > STEEP) {
      heightMap[col]--;
      heightMap[col-1]++;
    }
    if (col < columns - 1 && heightMap[col] - heightMap[col+1] > STEEP) {
      heightMap[col]--;
      heightMap[col+1]++;
    }
  }

  function loop() {
    ctx.clearRect(0, 0, w, h);

    // Update falling particles
    for (let i = falling.length - 1; i >= 0; i--) {
      const p = falling[i];
      p.vy += 0.05; // gravity
      p.x += p.vx;
      p.y += p.vy;

      const col = Math.floor(p.x / COL_W);
      if (col < 0 || col >= columns) { falling.splice(i, 1); continue; }

      const groundY = h - heightMap[col];
      if (p.y >= groundY) {
        // settle
        heightMap[col] += 1.6;
        slump(col);
        if (settled.length < MAX_SETTLED) {
          settled.push({ x: p.x, y: groundY - 1, r: p.r, c: p.c });
        }
        falling.splice(i, 1);
      }
    }

    // Draw settled pile
    ctx.save();
    for (const p of settled) {
      ctx.fillStyle = p.c;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.restore();

    // Draw active falling particles
    ctx.save();
    for (const p of falling) {
      ctx.fillStyle = p.c;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.restore();

    requestAnimationFrame(loop);
  }
  loop();

  // Spawn tied to scroll progress through hero
  ScrollTrigger.create({
    trigger: '#hero',
    start: 'top top',
    end: 'bottom top',
    scrub: true,
    onUpdate: self => {
      scrollProgress = self.progress;
    }
  });

  (function spawnLoop() {
    const now = performance.now();
    if (now - lastSpawnTime > 16 && scrollProgress > 0.05 && scrollProgress < 0.95 && settled.length < MAX_SETTLED) {
      // intensity: bell curve, peak at 50% scroll
      const intensity = Math.sin(scrollProgress * Math.PI);
      spawn(intensity);
      lastSpawnTime = now;
    }
    requestAnimationFrame(spawnLoop);
  })();
})();

// Hero scroll choreography — copy lifts, product pushes into compost pile
const heroCopy = document.getElementById('hero-copy');
const heroProduct = document.getElementById('hero-product');
const heroScrollHint = document.getElementById('hero-scroll-hint');

if (heroCopy) {
  gsap.to(heroCopy, {
    y: -70, opacity: 0,
    scrollTrigger: { trigger: '#hero', start: 'top top', end: 'bottom top', scrub: 1.1 }
  });
}
if (heroProduct) {
  gsap.to(heroProduct, {
    y: 40, scale: 1.04,
    scrollTrigger: { trigger: '#hero', start: 'top top', end: 'bottom top', scrub: 1.1 }
  });
}
gsap.to('#hero-bag', {
  y: 24, scale: 1.06,
  scrollTrigger: { trigger: '#hero', start: 'top top', end: 'bottom top', scrub: 1.1 }
});
if (heroScrollHint) {
  gsap.to(heroScrollHint, {
    opacity: 0, y: 12,
    scrollTrigger: { trigger: '#hero', start: 'top top', end: '15% top', scrub: true }
  });
}
gsap.utils.toArray('[data-parallax]').forEach(el => {
  const speed = parseFloat(el.dataset.parallax);
  gsap.to(el, { yPercent: speed * 80, scrollTrigger: { trigger: '#hero', start: 'top top', end: 'bottom top', scrub: 1.2 } });
});

// Clip-path reveal
const reveal = document.getElementById('reveal-image');
ScrollTrigger.create({
  trigger: '#reveal-sect', start: 'top 86%', end: 'top 8%', scrub: 0.95,
  onUpdate: self => {
    const p = self.progress;
    const eased = p < 0.5 ? 2*p*p : 1 - Math.pow(-2*p+2, 2)/2;
    const inset = 40 * (1 - eased);
    const radius = 20 * (1 - eased);
    reveal.style.clipPath = `inset(${inset}% ${inset}% ${inset}% ${inset}% round ${radius}px)`;
  }
});
gsap.to('#reveal-headline', { scale: 1.4, opacity: 0.05, scrollTrigger: { trigger: '#reveal-sect', start: 'top top', end: 'bottom bottom', scrub: 1.2 } });

// Reveal video — plays from time 0 only when section enters viewport. Pauses
// when leaving (so the cinematic moment is fresh every time, and no resources
// burn while it's offscreen).
(function revealVideoControl() {
  const v = document.getElementById('reveal-video');
  if (!v) return;
  try { v.pause(); v.currentTime = 0; } catch(e){}
  let primed = false;
  const primeVideo = () => {
    if (primed) return;
    primed = true;
    v.preload = 'auto';
    try { v.load(); } catch (e) {}
  };
  const playFromStart = () => {
    try { v.currentTime = 0; } catch(e){}
    const p = v.play();
    if (p && p.catch) p.catch(() => {}); // swallow autoplay-blocked rejections
  };
  // Kick off playback as soon as the reveal section enters view so the
  // cinematic moment feels timely on mobile/desktop.
  ScrollTrigger.create({
    trigger: '#reveal-sect',
    start: 'top 86%',
    end: 'bottom top',
    onEnter:      () => { primeVideo(); playFromStart(); },
    onEnterBack:  () => { primeVideo(); playFromStart(); },
    onLeave:     () => v.pause(),
    onLeaveBack: () => v.pause(),
  });
})();

// Anatomy pinned — progress-based panels (last beat shows well before section ends)
const panels = gsap.utils.toArray('.anatomy-panel');
const anatomyEl = document.getElementById('anatomy');
let activeAnatomyPanel = -1;
const IS_TABLET_OR_SMALL = window.matchMedia('(max-width: 1023px)').matches;

// Panel i becomes active at these scroll progress points (earlier = more dwell time)
const ANATOMY_THRESHOLDS = [0, 0.14, 0.36, 0.54, 1.01];

function showAnatomyPanel(index) {
  if (index === activeAnatomyPanel) return;
  activeAnatomyPanel = index;
  panels.forEach((p, i) => {
    const dir = p.classList.contains('right') ? 80 : -80;
    if (i === index) {
      gsap.set(p, { zIndex: 4 });
      gsap.to(p, { opacity: 1, x: 0, duration: 0.7, ease: 'expo.out' });
    } else {
      gsap.set(p, { zIndex: 1 });
      gsap.to(p, { opacity: 0, x: dir, duration: 0.45, ease: 'power2.in' });
    }
  });
}

if (IS_TABLET_OR_SMALL) {
  panels.forEach(panel => gsap.set(panel, { clearProps: 'all', opacity: 1, x: 0 }));
} else {
  panels.forEach((panel) => {
    const dir = panel.classList.contains('right') ? 80 : -80;
    gsap.set(panel, { opacity: 0, x: dir });
  });
  showAnatomyPanel(0);

  ScrollTrigger.create({
    trigger: '#anatomy',
    start: 'top top',
    end: 'bottom bottom',
    pin: '.anatomy-pin',
    pinSpacing: false,
    onUpdate: self => {
      let idx = 0;
      for (let i = 0; i < panels.length; i++) {
        if (self.progress >= ANATOMY_THRESHOLDS[i]) idx = i;
      }
      showAnatomyPanel(idx);
    }
  });
}

// Story — pinned chapters (same pattern as anatomy)
(function initStoryPin() {
  const storyScroll = document.getElementById('story-scroll');
  if (!storyScroll || IS_TABLET_OR_SMALL || REDUCE) return;

  const slides = storyScroll.querySelectorAll('.story-slide');
  const chapters = storyScroll.querySelectorAll('.story-chapter');
  const dots = storyScroll.querySelectorAll('.story-progress-track span');
  const counter = document.getElementById('story-cur');
  const STORY_THRESHOLDS = [0, 0.18, 0.42, 0.66, 1.01];
  let activeStory = -1;

  function showStoryChapter(index) {
    if (index === activeStory) return;
    activeStory = index;
    slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
    chapters.forEach(c => c.classList.toggle('is-active', Number(c.dataset.chapter) === index));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    if (counter) counter.textContent = String(index + 1).padStart(2, '0');
  }

  showStoryChapter(0);

  ScrollTrigger.create({
    trigger: storyScroll,
    start: 'top top',
    end: 'bottom bottom',
    pin: '.story-pin',
    pinSpacing: false,
    anticipatePin: 1,
    onUpdate: self => {
      let idx = 0;
      for (let i = 0; i < slides.length; i++) {
        if (self.progress >= STORY_THRESHOLDS[i]) idx = i;
      }
      showStoryChapter(idx);
    }
  });
})();

// Scroll-driven zoom — ramps harder in the back half so the bag fills the last panels
(function anatomyBagZoom() {
  const motion = document.getElementById('anatomy-bag-motion');
  const glow = document.getElementById('anatomy-bag-glow');
  if (!motion || REDUCE || IS_TABLET_OR_SMALL) return;

  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const endScale = isMobile ? 1.72 : 2.45;
  const endY = isMobile ? -16 : -36;
  const shadowStart =
    'drop-shadow(0 2px 3px rgba(0,0,0,0.06)) ' +
    'drop-shadow(0 14px 22px rgba(0,0,0,0.10)) ' +
    'drop-shadow(0 36px 56px rgba(0,0,0,0.08))';
  const shadowEnd =
    'drop-shadow(0 6px 12px rgba(0,0,0,0.14)) ' +
    'drop-shadow(0 32px 56px rgba(0,0,0,0.24)) ' +
    'drop-shadow(0 72px 110px rgba(0,0,0,0.2))';

  ScrollTrigger.create({
    trigger: '#anatomy',
    start: 'top top',
    end: 'bottom bottom',
    scrub: 1.1,
    onUpdate: self => {
      const p = self.progress;
      // Gentle early, aggressive late — compensates for longer scroll track
      const zoomP = p < 0.35 ? p * 0.45 : 0.16 + (p - 0.35) * 1.29;
      const t = Math.min(1, Math.max(0, zoomP));
      const scale = 1 + (endScale - 1) * t;
      const y = endY * t;
      gsap.set(motion, { scale, y, filter: shadowEnd });
      if (glow) {
        gsap.set(glow, {
          scale: 0.85 + t * 0.95,
          opacity: 0.2 + t * 0.45
        });
      }
    }
  });

  gsap.set(motion, { scale: 1, y: 0, filter: shadowStart });
})();

// Horizontal process
const track = document.getElementById('process-track');
const progFill = document.getElementById('process-progress-fill');
if (track) {
  if (IS_TABLET_OR_SMALL) {
    gsap.set(track, { x: 0 });
  } else {
  setTimeout(() => {
    const distance = track.scrollWidth - window.innerWidth;
    ScrollTrigger.create({
      trigger: '#process', start: 'top top', end: () => `+=${distance + window.innerHeight * 0.5}`,
      pin: '.process-pin', scrub: 1, anticipatePin: 1,
      onUpdate: self => { gsap.set(track, { x: -distance * self.progress }); progFill.style.width = (self.progress * 100) + '%'; }
    });
  }, 100);
  }
}

// ============ PRODUCT 3D TILT + SHEEN + IMAGE-SEQUENCE ============
if (!COARSE && !REDUCE && !IS_TABLET_OR_SMALL) {
  const stage = document.getElementById('product-stage');
  const bag2 = document.getElementById('product-bag');
  const sheen2 = document.getElementById('product-bag-sheen');
  stage.addEventListener('mousemove', e => {
    const rect = stage.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    gsap.to(bag2, { rotationY: x * 28, rotationX: -y * 20, duration: 0.8, ease: 'power3.out' });
    if (sheen2) {
      const bagRect = bag2.getBoundingClientRect();
      const lx = ((e.clientX - bagRect.left) / bagRect.width) * 100;
      const ly = ((e.clientY - bagRect.top) / bagRect.height) * 100;
      sheen2.style.background = `radial-gradient(circle at ${lx}% ${ly}%, rgba(255,255,255,0.45), rgba(255,255,255,0) 50%)`;
    }
  });
  stage.addEventListener('mouseleave', () => gsap.to(bag2, { rotationY: 0, rotationX: 0, duration: 1.2, ease: 'expo.out' }));
}

// 360° image sequence (Higgsfield turntable hook).
// Frames served from the HC_TURNTABLE CDN manifest (60 entries).
(function imageSequence() {
  if (SAVE_DATA) return;
  if (!window.HC_TURNTABLE || !window.HC_TURNTABLE.length) return;
  const FRAME_COUNT = 60;
  const padded = n => String(n).padStart(3, '0');

  function prepareTurntableImg(imgEl) {
    if (!imgEl) return;
    const pic = imgEl.closest('picture');
    if (pic) {
      pic.querySelectorAll('source').forEach((s) => s.remove());
      pic.replaceWith(imgEl);
    }
    imgEl.removeAttribute('srcset');
    imgEl.removeAttribute('sizes');
  }

  function decodeFrame(frame) {
    if (frame.decode) return frame.decode().catch(() => {});
    return Promise.resolve();
  }

  function decodeAllFrames() {
    return Promise.all(frames.map((frame) => {
      if (frame.complete) return decodeFrame(frame);
      return new Promise((resolve) => {
        frame.addEventListener('load', () => decodeFrame(frame).then(resolve), { once: true });
        frame.addEventListener('error', resolve, { once: true });
      });
    }));
  }

  function bindTurntable(imgEl, trigger, opts = {}) {
    if (!imgEl || !frames.length || imgEl.dataset.turntableBound) return;
    imgEl.dataset.turntableBound = '1';
    prepareTurntableImg(imgEl);

    const frontOffset = opts.frontOffset ?? 0;
    let lastIdx = -1;

    function setFrame(idx) {
      if (idx === lastIdx) return;
      const frame = frames[idx];
      if (!frame?.complete || !frame.naturalWidth) return;
      lastIdx = idx;
      imgEl.src = frame.src;
    }

    ScrollTrigger.create({
      trigger,
      start: opts.start ?? 'top bottom',
      end: opts.end ?? 'bottom top',
      scrub: opts.scrub ?? 0.8,
      onUpdate: self => {
        const raw = Math.min(FRAME_COUNT - 1, Math.floor(self.progress * FRAME_COUNT));
        const idx = (raw + frontOffset) % FRAME_COUNT;
        setFrame(idx);
      }
    });

    setFrame(frontOffset % FRAME_COUNT);
  }

  let frames = [];
  let started = false;
  let wired = false;
  const testFrame = new Image();
  testFrame.onload = () => {
    let settled = 0;
    const finish = () => {
      settled++;
      if (settled === FRAME_COUNT && !wired) {
        wired = true;
        hook();
      }
    };
    for (let i = 1; i <= FRAME_COUNT; i++) {
      const img = new Image();
      img.onload = finish;
      img.onerror = finish;
      img.src = window.HC_TURNTABLE[i - 1];
      frames.push(img);
    }
    async function hook() {
      await decodeAllFrames();

      // Product: rotate while the bag is actually in view
      bindTurntable(document.getElementById('product-bag-img'), '#product-bag', {
        start: 'top 85%',
        end: 'bottom 15%',
        frontOffset: 30,
        scrub: 0.8
      });

      // Anatomy (pinned): full 360° across four value-prop panels
      bindTurntable(document.getElementById('anatomy-bag-img'), '#anatomy', {
        start: 'top top',
        end: 'bottom bottom',
        scrub: 1,
        frontOffset: 0
      });

      ScrollTrigger.refresh();
      console.log('[Holy Cow] 360° turntable wired —', frames.filter(f => f.naturalWidth).length, '/', FRAME_COUNT, 'frames loaded.');
    }
  };
  testFrame.onerror = () => { /* silently fall back to single image */ };
  const startPreload = () => {
    if (started) return;
    started = true;
    testFrame.src = window.HC_TURNTABLE[0];
  };
  ScrollTrigger.create({ trigger: '#what-it-does', start: 'top bottom', once: true, onEnter: startPreload });
  ScrollTrigger.create({ trigger: '#product', start: 'top bottom', once: true, onEnter: startPreload });
})();

// Product section — all facts visible; scroll highlights + rotates bag
(function productShowcase() {
  const scrollEl = document.getElementById('product-scroll');
  const calloutWrap = document.getElementById('product-callouts');
  const lineWrap = document.getElementById('product-svg');
  const callouts = gsap.utils.toArray('.product-callout');
  const lines = document.querySelectorAll('.callout-line[data-line]');
  const dots = document.querySelectorAll('.callout-dot[data-dot]');
  const progDots = document.querySelectorAll('.product-progress-dot');
  let activeCallout = -1;
  let revealed = false;

  if (!scrollEl || !callouts.length) return;

  gsap.set(lines, { strokeDashoffset: 200 });
  gsap.set(dots, { opacity: 0 });

  function revealAll() {
    if (revealed) return;
    revealed = true;
    calloutWrap?.classList.add('is-revealed');
    lineWrap?.classList.add('is-revealed');
    lines.forEach((line, i) => {
      gsap.to(line, { strokeDashoffset: 0, duration: 0.85, delay: 0.06 * i, ease: 'power3.out' });
    });
    dots.forEach(dot => gsap.to(dot, { opacity: 0.85, duration: 0.5, ease: 'power2.out' }));
    setHighlight(0);
  }

  function setHighlight(index) {
    if (index === activeCallout) return;
    activeCallout = index;
    callouts.forEach((c, i) => c.classList.toggle('is-active', i === index));
    lines.forEach((line, i) => line.classList.toggle('is-active', i === index));
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    progDots.forEach((d, i) => d.classList.toggle('is-active', i === index));
  }

  if (REDUCE) {
    revealAll();
    gsap.set(lines, { strokeDashoffset: 0 });
    return;
  }

  if (IS_TABLET_OR_SMALL) {
    revealAll();
    setHighlight(-1);
  } else {
    ScrollTrigger.create({
      trigger: scrollEl,
      start: 'top 78%',
      once: true,
      onEnter: revealAll
    });

    ScrollTrigger.create({
      trigger: scrollEl,
      start: 'top top',
      end: 'bottom bottom',
      onUpdate: self => {
        if (!revealed) return;
        const idx = Math.min(callouts.length - 1, Math.floor(self.progress * callouts.length + 0.12));
        setHighlight(idx);
      }
    });
  }

  const bagWrap = document.getElementById('product-bag');
  if (bagWrap && !IS_TABLET_OR_SMALL) {
    gsap.fromTo(bagWrap,
      { y: 16, scale: 0.96 },
      {
        y: -12,
        scale: 1.03,
        ease: 'none',
        scrollTrigger: { trigger: scrollEl, start: 'top top', end: 'bottom bottom', scrub: 1 }
      }
    );
  }
})();

  // helpers used by ranges 14–18 (from the V3 script block)
  const easeOutCubic = t => 1 - Math.pow(1 - t, 3);
  const formatNum = (n) => Math.round(n).toLocaleString('en-US');

  // ===== Before/after sliders =====
  document.querySelectorAll('[data-ba-slider]').forEach(slider => {
    const after = slider.querySelector('.ba-after');
    const handle = slider.querySelector('.ba-handle');
    const input = slider.querySelector('[data-ba-input]');
    let dragging = false;
    const setProgress = (p) => {
      const clamped = Math.max(0, Math.min(100, p));
      slider.dataset.progress = clamped;
      after.style.clipPath = `inset(0 0 0 ${clamped}%)`;
      handle.style.left = clamped + '%';
      if (input) input.value = clamped;
    };
    setProgress(50);
    const fromEvent = (e) => {
      const rect = slider.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    };
    const onDown = (e) => { dragging = true; setProgress(fromEvent(e)); e.preventDefault(); };
    const onMove = (e) => { if (!dragging) return; setProgress(fromEvent(e)); };
    const onUp = () => { dragging = false; };
    slider.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    slider.addEventListener('touchstart', onDown, { passive: false });
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', onUp);
    if (input) input.addEventListener('input', () => setProgress(Number(input.value)));
    slider.tabIndex = 0;
    slider.addEventListener('keydown', (e) => {
      const cur = Number(slider.dataset.progress) || 50;
      if (e.key === 'ArrowLeft') { setProgress(cur - 4); e.preventDefault(); }
      if (e.key === 'ArrowRight') { setProgress(cur + 4); e.preventDefault(); }
    });

    // gentle idle nudge so users notice it's draggable
    if (!prefersReduced) {
      const showIo = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          showIo.unobserve(slider);
          let p = 50, dir = 1, frames = 0;
          const idle = () => {
            if (dragging) return;
            frames++;
            p += dir * 0.5;
            if (p > 62) dir = -1;
            if (p < 38) dir = 1;
            setProgress(p);
            if (frames < 90) requestAnimationFrame(idle);
            else setProgress(50);
          };
          requestAnimationFrame(idle);
        });
      }, { threshold: 0.5 });
      showIo.observe(slider);
    }
  });

  // ===== Results tabs =====
  const tabs = document.querySelectorAll('#ba-tabs .results-tab');
  if (tabs.length) {
    const showTarget = (id) => {
      ['ba-garden', 'ba-lawn'].forEach(t => {
        const el = document.getElementById(t);
        if (el) el.hidden = (t !== id);
        const cap = document.getElementById('ba-caption-' + t.replace('ba-', ''));
        if (cap) cap.hidden = (t !== id);
      });
      tabs.forEach(t => {
        const on = t.dataset.target === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    };
    tabs.forEach(t => t.addEventListener('click', () => showTarget(t.dataset.target)));
  }

  // ===== Coverage calculator =====
  const calcArea = document.getElementById('calc-area');
  const calcDepth = document.getElementById('calc-depth');
  const calcBags = document.getElementById('calc-bags');
  const calcCost = document.getElementById('calc-cost');
  if (calcArea && calcDepth && calcBags && calcCost) {
    const calcRoot = document.getElementById('calculator');
    const PRICE = (calcRoot && parseFloat(calcRoot.dataset.unitPrice)) || 17.40;
    const COVERAGE_SQFT_PER_BAG_AT_1IN = 5; // ~4 lb bag covers ~5 sqft at 1 inch
    const update = () => {
      const area = Math.max(1, Number(calcArea.value) || 0);
      const depth = Math.max(0.25, Number(calcDepth.value) || 1);
      const bags = Math.max(1, Math.ceil((area * depth) / COVERAGE_SQFT_PER_BAG_AT_1IN));
      const cost = bags * PRICE;
      // little scramble
      const animateNum = (el, to, prefix = '', suffix = '') => {
        const from = Number(el.dataset.cur) || 0;
        const start = performance.now();
        const dur = 420;
        const tick = (now) => {
          const t = Math.min(1, (now - start) / dur);
          const v = from + (to - from) * easeOutCubic(t);
          el.textContent = prefix + (suffix === '%' ? Math.round(v) + '%' : formatNum(v)) + suffix;
          if (t < 1) requestAnimationFrame(tick);
          else el.dataset.cur = to;
        };
        requestAnimationFrame(tick);
      };
      animateNum(calcBags, bags, '', '');
      animateNum(calcCost, cost, '$', '');
    };
    calcArea.addEventListener('input', update);
    calcDepth.addEventListener('change', update);
    update();
  }

  // ===== Spotlight (cursor-following) =====
  document.querySelectorAll('.has-spotlight').forEach(el => {
    el.addEventListener('pointermove', (e) => {
      const rect = el.getBoundingClientRect();
      el.style.setProperty('--mx', (e.clientX - rect.left) + 'px');
      el.style.setProperty('--my', (e.clientY - rect.top) + 'px');
    });
  });

  // ===== Scroll-fade reveal for new elements not covered by GSAP reveal-up =====
  if ('IntersectionObserver' in window) {
    const fadeIo = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); fadeIo.unobserve(entry.target); }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.scroll-fade-in').forEach(el => fadeIo.observe(el));
  }

  // ===== Buy section — bundle selector + price scramble + add to cart (Batch D) =====
  // Each bundle card carries its own data-variant-id (real product variant, priced
  // in the Shopify admin); cards without one fall back to data-bundle × the single
  // variant. Registered with HC so the theme editor re-inits it on shopify:section:load.
  function initBuy(root) {
    root = root || document.getElementById('buy');
    if (!root) return;
    const bundleRow = root.querySelector('#bundle-row');
    const price = root.querySelector('#price-scramble');
    const unit = root.querySelector('#price-unit');
    const cta = root.querySelector('#buy-cta');
    const triggers = [];

    // Bundle selector (V2 3941–3957, scoped to root)
    if (bundleRow) {
      const cards = bundleRow.querySelectorAll('.bundle-card');
      const select = (card) => {
        cards.forEach(c => { c.classList.toggle('is-selected', c === card); c.setAttribute('aria-checked', c === card ? 'true' : 'false'); });
        if (price) price.textContent = '$' + Number(card.dataset.price).toFixed(2);
        if (unit) unit.textContent = card.dataset.unit;
        if (cta) cta.firstChild && (cta.firstChild.textContent = card.dataset.cta);
      };
      cards.forEach(c => c.addEventListener('click', () => select(c)));
      const initial = bundleRow.querySelector('.bundle-card.is-selected') || cards[1] || cards[0];
      if (initial) select(initial);
    }

    // Price scramble (V2 3741–3759; TARGET = the selected bundle's price; digits
    // scramble, all other chars pass through — equivalent to V2 for "$NN.NN")
    if (price) {
      const TARGET = price.textContent;
      triggers.push(ScrollTrigger.create({ trigger: root, start: 'top 72%', once: true, onEnter: () => {
        const chars = '0123456789'; const dur = 1400; const start = performance.now();
        function tick(t) {
          const p = Math.min((t - start) / dur, 1);
          let r = '';
          for (let i = 0; i < TARGET.length; i++) {
            const tc = TARGET[i];
            if (i / TARGET.length < p) r += tc;
            else if (tc >= '0' && tc <= '9') r += chars[Math.floor(Math.random() * 10)];
            else r += tc;
          }
          price.textContent = r;
          if (p < 1) requestAnimationFrame(tick); else price.textContent = TARGET;
        }
        requestAnimationFrame(tick);
      } }));
    }

    // Add to cart — posts the selected card's own variant (qty 1); cards without
    // a variant fall back to data-bundle × the row's single variant.
    if (cta && bundleRow && window.HC && HC.cart) {
      const fallbackId = parseInt(bundleRow.dataset.variantId, 10);
      let busy = false;
      cta.addEventListener('click', () => {
        if (busy) return;
        const sel = bundleRow.querySelector('.bundle-card.is-selected');
        let variantId = sel ? parseInt(sel.dataset.variantId, 10) || 0 : 0;
        let qty = 1;
        if (!variantId) {
          variantId = fallbackId;
          qty = sel ? parseInt(sel.dataset.bundle, 10) || 1 : 1;
        }
        if (!variantId) return;
        const label = cta.firstChild;
        const original = label.textContent;
        busy = true;
        label.textContent = 'Adding…';
        HC.cart.add(variantId, qty).then(() => {
          label.textContent = 'Added to cart ✓';
          setTimeout(() => { label.textContent = original; busy = false; }, 2400);
        }).catch(() => {
          label.textContent = 'Couldn’t add — try again';
          setTimeout(() => { label.textContent = original; busy = false; }, 2400);
        });
      });
    }

    return function teardown() { triggers.forEach(t => t.kill()); };
  }
  if (window.HC && HC.register) { HC.register('buy', initBuy); HC.initSection(document.getElementById('buy')); }
  else { initBuy(null); }

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
